<template>
  <div>
    <base-loading
      title="Obteniendo tarjetas de crédito"
      v-if="isLoading"
    ></base-loading>
    <div v-else-if="showResult">
      <v-container class="fill-height" v-if="isSuccess">
        <v-row align="center" justify="center">
          <v-col xl="4" lg="5" md="6">
            <v-card shaped outlined class="py-5">
              <v-card-text class="px-8">
                <div class="text-center mb-4">
                  <div>
                    <v-avatar size="96" class="success-icon">
                      <v-icon dark size="48" color="primary">mdi-check</v-icon>
                    </v-avatar>
                  </div>
                  <div class="text-title mb-0 black--text mt-4">
                    ¡Pago exitoso!
                  </div>
                  <div class="mt-3 text-subtitle-1">Agradecemos tu pago</div>
                  <v-divider class="mt-4"></v-divider>
                  <v-simple-table class="mt-3">
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td
                            class="text-left font-weight-bold text-subtitle-1"
                          >
                            Cantidad pagada
                          </td>
                          <td class="text-right text-subtitle-1">
                            {{ amoutPaid }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <div class="mt-7">
                    <v-btn
                      large
                      rounded
                      block
                      color="primary"
                      class="font-weight-bold mt-5"
                      :to="{ name: 'logout' }"
                      >Finalizar</v-btn
                    >
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-container class="fill-height" v-else>
        <v-row align="center" justify="center">
          <v-col xl="4" lg="5" md="6">
            <v-card shaped outlined class="py-5">
              <v-card-text class="px-8">
                <div class="text-center mb-4">
                  <div>
                    <v-avatar size="96" class="error-icon">
                      <v-icon dark size="48" color="error">mdi-close</v-icon>
                    </v-avatar>
                  </div>
                  <div class="text-title mb-0 black--text mt-4">
                    ¡Error al procesar pago!
                  </div>
                  <div class="mt-3 text-subtitle-1">
                    Lo sentimos, no pudimos procesar tu pago, por favor intenta
                    más tarde.
                  </div>
                  <div class="mt-3 text-subtitle-1">
                    Si el error continua, contacta a tu banco.
                  </div>
                  <div class="mt-7">
                    <v-btn
                      large
                      rounded
                      block
                      color="primary"
                      class="font-weight-bold mt-5"
                      @click="onRestart"
                      >Reintentar</v-btn
                    >
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-container class="fill-height" v-else>
      <v-row align="center" justify="center">
        <v-col xl="4" lg="5" md="6">
          <v-card shaped outlined class="py-5" v-if="payment">
            <v-card-title class="justify-center font-weight-bold">
              Pago con Tarjeta de Crédito/Débito
            </v-card-title>
            <v-card-text class="px-8">
              <div class="text-center mb-4">
                <div class="d-flex align-center justify-center mb-1 mt-4">
                  <span class="text-h4 mb-0 mr-2 black--text">$</span>
                  <span class="text-h2 mb-0 black--text font-weight-regular">{{
                    formatCurrency(payment.amount)
                  }}</span>
                </div>
                <div class="total text-uppercase">Total a pagar</div>
                <v-form ref="payment" v-model="valid">
                  <div class="mt-7">
                    <v-select
                      outlined
                      rounded
                      required
                      :items="cards"
                      :rules="rules.creditCard"
                      item-text="display_name"
                      item-value="card_id"
                      label="Seleccion tarjeta"
                      v-model="mutableCreditCardId"
                    ></v-select>
                    <v-btn
                      large
                      rounded
                      block
                      color="primary"
                      class="font-weight-bold"
                      :loading="isPaying"
                      :disabled="!validateForm"
                      @click="onPay"
                      >{{ paymentButton }}</v-btn
                    >
                  </div>
                  <div class="mt-6">
                    <v-btn
                      text
                      rounded
                      large
                      block
                      outlined
                      color="primary"
                      class="font-weight-bold"
                      :to="{ name: 'add-card' }"
                      >Agregar nueva tarjeta</v-btn
                    >
                    <v-btn
                      large
                      text
                      rounded
                      block
                      color="primary"
                      class="font-weight-bold mt-5"
                      @click="$router.push({ name: 'payments' })"
                      >Regresar</v-btn
                    >
                  </div>
                </v-form>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { to } from '@/helpers'
import { PaymentService } from '@/api/api.service'
import { pathOr } from '@/helpers/functional'
import rules from '@/constants/input-validation'
export default {
  props: {},
  data() {
    return {
      rules,
      valid: true,
      reference: null,
      isLoading: true,
      isPaying: false,
      isSuccess: true,
      showResult: false,
      mutableCreditCardId: null,
      amoutPaid: 0
    }
  },
  computed: {
    ...mapGetters({
      user: 'getSessionUser',
      payment: 'getSessionPayment',
      cards: 'getSessionCards'
    }),
    paymentButton() {
      const amount = this.formatCurrency(this.payment.amount, 'currency')
      return `Pagar ${amount}`
    }
  },
  mounted() {
    if (!this.payment) {
      this.$router.push({ name: 'payments' })
    }
    this.checkAvailableCards()
  },
  methods: {
    async checkAvailableCards() {
      this.isLoading = true
      if (this.cards.length < 1) {
        this.$router.push({ name: 'add-card' })
      }
      this.isLoading = false
    },
    formatCurrency(value, param) {
      return this.$options.filters.thousands(value, param)
    },
    async onPay(evt) {
      evt.preventDefault()
      if (this.validateForm()) {
        this.isPaying = true
        const paymentId = this.payment.id
        const payload = {
          card_id: this.mutableCreditCardId
        }
        if (paymentId) {
          payload.payment_id = paymentId
        }
        const [err, data] = await to(PaymentService.payByCreditCard(payload))
        if (err) {
          this.isPaying = false
          this.isSuccess = false
          this.error = this.$t('errors.unknownError')
          this.amoutPaid = 0
        } else {
          const status = pathOr(
            null,
            ['data', 'data', 'payment', 'status'],
            data
          )
          const amount = pathOr(
            null,
            ['data', 'data', 'payment', 'amount'],
            data
          )

          if (status === 'CHARGED') {
            this.isPaying = false
            this.isSuccess = true
            this.amoutPaid = this.formatCurrency(amount, 'currency')
          } else {
            this.isSuccess = false
            this.isPaying = false
          }
        }
        this.showResult = true
      }
    },
    onPrint() {
      window.print()
    },
    onRestart() {
      this.showResult = false
    },
    validateForm() {
      return this.$refs.payment.validate()
    }
  },
  components: {}
}
</script>
<style lang="scss" scoped>
.text-h2 {
  font-size: 3.5rem !important;
}
.text-title {
  font-weight: 400 !important;
  font-size: 1.5rem;
}
.success-icon {
  background-color: rgba(146, 72, 249, 0.1);
}
.error-icon {
  background-color: rgba(255, 56, 104, 0.1);
}
</style>
